export var UseMarkdownFor;
(function (UseMarkdownFor) {
    UseMarkdownFor["none"] = "none";
    UseMarkdownFor["title"] = "title";
    UseMarkdownFor["detail"] = "detail";
    UseMarkdownFor["both"] = "both";
})(UseMarkdownFor || (UseMarkdownFor = {}));
